import PowerDate from '#metatypes/power_date.js'
import PowerBool from '#metatypes/power_bool.js'
import { define, type, auto, Record, Collection } from 'type-r'
import ConsentForm from './consent'

@define
export default class BloodThinnersForm extends ConsentForm {
}
